<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div class="manage-user-page">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          {{ $t("message.UserManagement") }}
        </div>
        <v-card-text>
          <div>
            <v-card elevation="10" class="user-filter-card">
              <v-row align="center">
                <v-col cols="12" sm="6" md="4" lg="4" style="margin-top: 25px;">
                  <v-text-field
                    :label="$t('message.Search')"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchDataUser(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5" lg="4" class="pt-3 user-filter-actions">
                  <v-btn
                    color="primary"
                    class="ma-2 white--text"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click="GetUserList()"
                    >{{ $t("message.Search") }}
                    <v-icon right>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    color="green"
                    class="ma-2 white--text"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click="OpenUserDetailDialog(null, 'create')"
                    >{{ $t("message.Create") }}
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    color="green"
                    class="ma-2 white--text"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click="exportExcel"
                    >{{ $t("message.ExportExcel") }}
                    <v-icon right>mdi-file-excel-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <v-card elevation="10" class="user-list-card">
            <v-card elevation="6" class="user-table-card">
              <div class="table-responsive">
                <v-data-table
                  class="user-list-table"
                  :headers="headers"
                  :items="ListData"
                  hide-default-footer
                  :items-per-page="itemsPerPage"
                  :mobile-breakpoint="0"
                  :page.sync="page"
                  single-line
                  hide-details
                >
                  <template
                    v-if="!$vuetify.breakpoint.smAndDown"
                    v-slot:item="{ item, index }"
                  >
                    <tr>
                      <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                      <td class="header-table-css">{{ item.username }}</td>
                      <td class="header-table-css">
                        {{ item.firstname + " " + item.lastname }}
                      </td>
                      <td class="header-table-css">{{ item.email }}</td>
                      <td class="header-table-css">{{ item.roleName }}</td>
                      <td class="header-table-css">
                        {{ ChangeFormatDate(item.createTime) }}
                      </td>
                      <td class="user-status-cell">
                        <v-btn
                          :color="GetColor(item.active)"
                          rounded
                          class="text-capitalize"
                          depressed
                          style="width: 100px"
                        >
                          <span :style="{ color: GetColorText(item.active) }">{{
                            item.active == true ? "Active" : "InActive"
                          }}</span>
                        </v-btn>
                      </td>
                      <td class="text-center">
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="orange"
                          @click="OpenUserDetailDialog(item.userID, 'edit')"
                        >
                          <v-icon dark> mdi-pencil-outline </v-icon>
                        </v-btn>
                        <template>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="red"
                            @click="InActiveUserByUserID(item.userID)"
                          >
                            <v-icon dark>mdi-trash-can-outline </v-icon>
                          </v-btn>
                        </template>
                      </td>
                    </tr>
                  </template>
                  <template v-else v-slot:item="{ item, index }">
                    <tr>
                      <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                      <td class="header-table-css">{{ item.username }}</td>
                      <td class="header-table-css">
                        {{ item.firstname + " " + item.lastname }}
                      </td>
                      <td class="header-table-css">{{ item.roleName }}</td>
                      <td class="text-center">
                        <v-btn
                          :color="GetColor(item.active)"
                          rounded
                          class="text-capitalize"
                          depressed
                          style="width: 100px"
                        >
                          <span :style="{ color: GetColorText(item.active) }">{{
                            item.active == true ? "Active" : "InActive"
                          }}</span>
                        </v-btn>
                      </td>
                      <td class="text-center">
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="orange"
                          @click="OpenUserDetailDialog(item.userID, 'edit')"
                        >
                          <v-icon dark> mdi-pencil-outline </v-icon>
                        </v-btn>
                        <template>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="red"
                            @click="InActiveUserByUserID(item.userID)"
                          >
                            <v-icon dark>mdi-trash-can-outline </v-icon>
                          </v-btn>
                        </template>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-card>
            <v-row class="mt-5 user-pagination-row" align="center">
              <v-col cols="12" md="8" lg="9" class="user-pagination-col">
                <v-pagination
                  v-model="page"
                  :total-visible="paginationTotalVisible"
                  :length="pageCount"
                  @input="ChangePage(page)"
                ></v-pagination>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3" class="user-page-size-col">
                <v-autocomplete
                  class="user-page-size"
                  dense
                  solo
                  v-model="itemsPerPage"
                  @input="ChangePerPage(itemsPerPage)"
                  :items="items"
                  label="10/page"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog
      v-model="UserDetailDialog"
      persistent
      max-width="800px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="rounded-xl elevation-6 user-dialog-card">
        <v-card-title
          class="d-flex align-center justify-space-between py-4 px-6"
        >
          <span class="text-h6 font-weight-bold">{{
            $t("message.ManageUser")
          }}</span>
          <v-btn
            icon
            variant="text"
            color="grey"
            @click="UserDetailDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6 user-dialog-content">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="Username"
                outlined
                density="comfortable"
                class="rounded-lg"
              >
                <template v-slot:label>
                  {{ $t("message.Username") }} <span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="Password"
                :type="ShowPassword ? 'text' : 'password'"
                :append-icon="ShowPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="ShowPassword = !ShowPassword"
                outlined
                density="comfortable"
                class="rounded-lg"
              >
                <template v-slot:label>
                  {{ $t("message.Password") }} <span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="FirstName"
                outlined
                density="comfortable"
                class="rounded-lg"
              >
                <template v-slot:label>
                  {{ $t("message.FirstName") }}
                  <span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="LastName"
                outlined
                density="comfortable"
                class="rounded-lg"
              >
                <template v-slot:label>
                  {{ $t("message.LastName") }}
                  <span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="Email"
                outlined
                density="comfortable"
                class="rounded-lg"
              >
                <template v-slot:label>
                  {{ $t("message.Email") }}
                  <span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="Telephone"
                label="Telephone"
                outlined
                density="comfortable"
                class="rounded-lg"
              >
                <template v-slot:label>
                  {{ $t("message.PhoneNumber") }}
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="RoleId"
                :items="RoleListData"
                item-text="roleName"
                item-value="roleId"
                outlined
                density="comfortable"
                class="rounded-lg"
              >
                <template v-slot:label>
                  {{ $t("message.Role") }}
                  <span style="color: red">*</span>
                </template>
              </v-select>
            </v-col>
            <!-- <v-col cols="12" md="6">
              <v-select
                :items="SectionList"
                item-text="sectionName"
                item-value="sectionID"
                outlined
                density="comfortable"
                class="rounded-lg"
                v-model="SectionID"
              >
                <template v-slot:label>
                  {{ $t("message.SectionName") }}
                  <span style="color: red">*</span>
                </template>
              </v-select>
            </v-col> -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="user-dialog-actions">
          <v-radio-group v-model="ActiveStatus" row>
            <v-radio :label="$t('message.Active')" value="1"></v-radio>
            <v-radio :label="$t('message.InActive')" value="2"></v-radio>
          </v-radio-group>
          <div class="user-action-buttons">
            <v-btn
              v-if="EditStatus"
              color="green"
              class="rounded-lg px-6 white--text"
              :block="$vuetify.breakpoint.xsOnly"
              @click="UpdateDataUser()"
            >
              {{ $t("message.Update") }}
            </v-btn>
            <v-btn
              v-else
              color="green"
              class="rounded-lg px-6 white--text"
              :block="$vuetify.breakpoint.xsOnly"
              @click="AddDataUser()"
            >
              {{ $t("message.Create") }}
            </v-btn>
            <v-btn
              color="grey-lighten-1"
              class="rounded-lg px-6"
              :block="$vuetify.breakpoint.xsOnly"
              @click="CloseUserDetailDialog()"
            >
              {{ $t("message.Cancel") }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ChangeActiveUserDialog" persistent width="500">
      <v-card>
        <v-card-title>
          <template v-if="Active_Register">
            <h4>คุณต้องการ Inactive Username นี้ ใช่หรือไม่ ?</h4>
          </template>
          <template v-else>
            <h4>คุณต้องการ Active Username นี้ ใช่หรือไม่ ?</h4>
          </template>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6"></v-col>
            <v-col cols="12" md="6"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-btn
                block
                color="#5cb85c"
                style="color: white"
                @click="ChangeActiveUsername()"
                class="rounded-lg"
                x-large
                >YES</v-btn
              >
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                block
                color="#d9534f"
                style="color: white"
                @click="CloseChangeActiveUserDialog()"
                class="rounded-lg"
                x-large
                >NO</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as XLSX from "xlsx-js-style";

export default {
  name: "ManageUser",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      UserDetailDialog: false,
      ChangeActiveUserDialog: false,

      items: [10, 15, 20, 50, 100],
      pageCount: 0, //จำนวนหน้าทั้งหมด
      page: 1, //อยู่หน้าที่เท่าไร
      itemsPerPage: 10, //จำนวนรายการต่อหน้า
      search: "",
      no_run: 0,

      UserName_Register: "",
      UserId_Register: null,
      Active_Register: false,

      ListData: [],
      RoleListData: [],
      RoleId: null,
      UserID: null,
      MemberList: [],
      RedemptionTypeList: [],
      DepartmentList: [],
      UserLevelList: [],
      SearchMemberID: null,
      FirstName: "",
      LastName: "",
      Username: "",
      Password: "",
      MemberID: "",
      CardID: "",
      TenantID: "",
      Tenant: "",
      Email: "",
      Telephone: "",
      ShowPassword: false,
      RedemptionType: null,
      UserLevel: null,
      ActiveStatus: null,
      Department: null,
      RedemptionStatus: false,
      SectionList: [],
      SectionID: null,
      EditStatus: false,
    };
  },
  computed: {
    headers() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return [
          {
            text: this.$t("message.No"),
            sortable: false,
            align: "left",
          },
          {
            text: this.$t("message.Username"),
            align: "left",
            sortable: false,
          },
          {
            text: this.$t("message.FullName"),
            align: "left",
            sortable: false,
          },
          {
            text: this.$t("message.RoleName"),
            align: "left",
            sortable: false,
          },
          {
            text: this.$t("message.Status"),
            align: "center",
            sortable: false,
          },
          {
            text: this.$t("message.Action"),
            align: "center",
            sortable: false,
          },
        ];
      }

      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.Username"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.FullName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Email"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.RoleName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.CreateTime"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    paginationTotalVisible() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 5;
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        return 7;
      }

      return 10;
    },
  },

  async mounted() {
    let self = this;
    await self.GetUserList();
    await self.GetRoleUser();
    // await self.getDataSectionList();
  },

  methods: {
    TogglePassword() {
      let self = this;
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        self.ShowPassword = false;
      } else {
        x.type = "password";
        self.ShowPassword = true;
      }
    },

    GetUserList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}Management/getUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}Management/getUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    SearchDataUser(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getUserList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    async exportExcel() {
      let self = this;
      self.LoadingDialog = true;
      try {
        const response = await axios.get(`${self.url}Management/exportUserList`);
        if (response.data.status != 0) {
          throw new Error(response.data.message || "Unable to export data.");
        }

        const data = response.data.data || [];
        if (data.length === 0) {
          Swal.fire({
            icon: "info",
            title: "No data",
            text: "No user data was found.",
          });
          return;
        }

        const headers = [
          self.$t("message.No"),
          self.$t("message.Username"),
          self.$t("message.FullName"),
          self.$t("message.Email"),
          self.$t("message.PhoneNumber"),
          self.$t("message.RoleName"),
          self.$t("message.CreateTime"),
          self.$t("message.Status"),
        ];
        const rows = data.map((item, index) => [
          index + 1,
          item.username || "",
          `${item.firstname || ""} ${item.lastname || ""}`.trim(),
          item.email || "",
          item.telephone || "",
          item.roleName || "",
          self.ChangeFormatDate(item.createTime),
          item.active == true ? "Active" : "InActive",
        ]);

        const worksheet = XLSX.utils.aoa_to_sheet([
          ["User Management"],
          [],
          headers,
          ...rows,
        ]);
        worksheet["!merges"] = [
          {
            s: { r: 0, c: 0 },
            e: { r: 0, c: headers.length - 1 },
          },
        ];
        worksheet["A1"].s = {
          font: {
            bold: true,
            color: { rgb: "333333" },
            sz: 16,
          },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "BFBFBF" },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
        worksheet["!rows"] = [{ hpt: 26 }, { hpt: 8 }, { hpt: 22 }];

        headers.forEach((header, index) => {
          const cellAddress = XLSX.utils.encode_cell({ r: 2, c: index });
          worksheet[cellAddress].s = {
            font: {
              bold: true,
              color: { rgb: "333333" },
            },
            fill: {
              patternType: "solid",
              fgColor: { rgb: "BDD7EE" },
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
            },
            border: {
              top: { style: "thin", color: { rgb: "B7B7B7" } },
              bottom: { style: "thin", color: { rgb: "B7B7B7" } },
              left: { style: "thin", color: { rgb: "B7B7B7" } },
              right: { style: "thin", color: { rgb: "B7B7B7" } },
            },
          };
        });
        worksheet["!cols"] = [
          { wch: 8 },
          { wch: 22 },
          { wch: 28 },
          { wch: 30 },
          { wch: 18 },
          { wch: 24 },
          { wch: 22 },
          { wch: 14 },
        ];
        worksheet["!autofilter"] = {
          ref: `A3:${XLSX.utils.encode_col(headers.length - 1)}${
            rows.length + 3
          }`,
        };

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
        const exportDate = new Date();
        const exportDateText =
          String(exportDate.getDate()).padStart(2, "0") +
          "_" +
          String(exportDate.getMonth() + 1).padStart(2, "0") +
          "_" +
          exportDate.getFullYear().toString();
        const exportTimestamp =
          String(exportDate.getHours()).padStart(2, "0") +
          String(exportDate.getMinutes()).padStart(2, "0") +
          String(exportDate.getSeconds()).padStart(2, "0");
        XLSX.writeFile(
          workbook,
          `ManageUser_${exportDateText}_${exportTimestamp}.xlsx`
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error...",
          width: 900,
          text:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error,
        });
      } finally {
        self.LoadingDialog = false;
      }
    },

    ChangeActiveUsername() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        UserId: self.UserId_Register,
        Active: !self.Active_Register,
      };
      axios
        .post(`${self.url}Management/ChangeActiveUsername`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.GetUserList();
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    getDataUserByUserID(userid) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        userID: userid,
      };
      axios
        .post(`${self.url}Management/getDataUserByUserID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.UserID = response.data.data.userID;
            self.RoleId = response.data.data.roleID;
            self.Username = response.data.data.username;
            self.Password = response.data.data.password;
            self.FirstName = response.data.data.firstname;
            self.LastName = response.data.data.lastname;
            self.Email = response.data.data.email;
            self.Telephone = response.data.data.telephone;
            self.ActiveStatus =
              response.data.data.active == true
                ? "1"
                : response.data.data.active == false
                ? "2"
                : null;
            // self.SectionID = response.data.data.sectionID;
            self.UserDetailDialog = true;
          } else if (response.data.status == 1) {
            Swal.fire({
              icon: "warning",
              title: "warning",
              width: 500,
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    InActiveUserByUserID(userid) {
      let self = this;
      let temp = {
        userID: userid,
      };
      Swal.fire({
        text: "คุณต้องการ In Active User นี้ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          self.LoadingDialog = true;
          axios
            .post(`${self.url}Management/InActiveUserByUserID`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.GetUserList();
              }
            })
            .catch(function (error) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 500,
                text: error.response.data.message,
              });
            })
            .finally(() => {
              self.LoadingDialog = false;
            });
        }
      });
    },

    UpdateDataUser() {
      let self = this;
      if (
        self.Username == "" ||
        self.Password == "" ||
        self.FirstName == "" ||
        self.LastName == "" ||
        self.Email == "" ||
        self.ActiveStatus == null ||
        self.RoleId == null ||
        self.UserID == null
      ) {
        Swal.fire({
          icon: "error",
          title: "Error...",
          width: 500,
          text: "กรุณาใส่กรอกข้อมูลให้ครบถ้วน",
        });
      } else {
        let temp = {
          UserId: self.UserID,
          roleId: self.RoleId,
          Username: self.Username,
          Password: self.Password,
          FirstName: self.FirstName,
          LastName: self.LastName,
          Telephone: self.Telephone,
          Email: self.Email,
          active: self.ActiveStatus == "1" ? true : false,
        };
        self.LoadingDialog = true;
        axios
          .post(`${self.url}Management/UpdateDataUser`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.CloseUserDetailDialog();
              self.GetUserList();
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    AddDataUser() {
      let self = this;
      if (
        self.Username == "" ||
        self.Password == "" ||
        self.FirstName == "" ||
        self.LastName == "" ||
        self.Email == "" ||
        self.ActiveStatus == null ||
        self.RoleId == null
      ) {
        Swal.fire({
          icon: "error",
          title: "Error...",
          width: 500,
          text: "กรุณาใส่กรอกข้อมูลให้ครบถ้วน",
        });
      } else {
        let temp = {
          Username: self.Username,
          Password: self.Password,
          FirstName: self.FirstName,
          LastName: self.LastName,
          Telephone: self.Telephone,
          Email: self.Email,
          active: self.ActiveStatus == "1" ? true : false,
          roleId: self.RoleId,
        };
        self.LoadingDialog = true;
        axios
          .post(`${self.url}Management/AddDataUser`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.GetUserList();
              self.CloseUserDetailDialog();
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    GetRoleUser() {
      let self = this;
      axios
        .get(`${self.url}Management/GetRoleName`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RoleListData = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    getDataSectionList() {
      let self = this;
      axios
        .get(`${self.url}Management/getDataSectionDropdownList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.SectionList = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    OpenUserDetailDialog(userid, type) {
      let self = this;
      if (type == "edit" && userid != null) {
        self.EditStatus = true;
        self.getDataUserByUserID(userid);
      } else {
        self.ClearDataUser();
        self.UserDetailDialog = true;
      }
      self.UserID = userid;
    },

    CloseUserDetailDialog() {
      let self = this;
      self.ClearDataUser();
      self.UserDetailDialog = false;
    },

    OpenChangeActiveUserDialog(username, userid, active) {
      let self = this;
      // self.ChangeActiveUserDialog = true;
      self.UserName_Register = username;
      self.UserId_Register = userid;
      self.Active_Register = active;
    },

    // CloseChangeActiveUserDialog() {
    //   let self = this;
    //   self.ChangeActiveUserDialog = false;
    // },

    ClearDataUser() {
      let self = this;
      self.Username_Register = "";
      self.FirstName = "";
      self.LastName = "";
      self.Username = "";
      self.Password = "";
      self.MemberID = "";
      self.CardID = "";
      self.TenantID = "";
      self.Tenant = "";
      self.Email = "";
      self.RoleId = 0;
      self.Telephone = "";
      self.RedemptionType = null;
      self.UserLevel = null;
      self.ActiveStatus = null;
      self.Department = null;
      self.SectionID = null;
      self.EditStatus = false;
      self.RedemptionStatus = false;
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.manage-user-page {
  margin-left: 10px;
  margin-right: 10px;
}

.user-filter-card,
.user-list-card {
  padding: 2%;
  margin-top: 2%;
  margin-bottom: 2%;
}

.user-filter-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.user-table-card {
  padding: 16px;
  margin-bottom: 16px;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.user-list-table {
  min-width: 1080px;
  color: #332f2fde;
}

.user-status-cell {
  padding-bottom: 5px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}

.user-pagination-col {
  display: flex;
  justify-content: center;
}

.user-page-size-col {
  display: flex;
  justify-content: flex-end;
}

.user-page-size {
  max-width: 180px;
}

.user-dialog-card {
  overflow: hidden;
}

.user-dialog-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px 16px;
}

.user-action-buttons {
  display: flex;
  gap: 8px;
}

@media (max-width: 959px) {
  .user-list-table {
    min-width: 760px;
  }

  .user-page-size-col {
    justify-content: center;
  }

  .user-page-size {
    max-width: 220px;
  }
}

@media (max-width: 599px) {
  .manage-user-page {
    margin-left: 0;
    margin-right: 0;
  }

  .user-filter-card,
  .user-list-card {
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .user-filter-actions {
    display: block;
    padding-top: 0 !important;
  }

  .user-table-card {
    padding: 8px;
  }

  .user-list-table {
    min-width: 700px;
  }

  .user-dialog-card {
    border-radius: 0 !important;
  }

  .user-dialog-content {
    padding: 16px !important;
  }

  .user-dialog-actions {
    display: block;
    padding: 16px;
  }

  .user-action-buttons {
    display: block;
  }

  .user-action-buttons .v-btn {
    margin-top: 8px;
  }
}
</style>
